<template>
  <div
    v-b-tooltip.hover
    :title="$t('global.click_to_expand')"
    v-html="results"
    class="pointer"
    @click="expand = !expand">
  </div>
</template>

<script>

  export default {
    name: 'ColumnExtraExpand',
    props: ['row', 'column', 'field', 'image'],
    data: () => {
      return {
        expand: false
      }
    },
    methods: {},
    computed: {
      results: {
        cache: false,
        get: function () {
          const items = this.row[this.column];
          let itemsHtml = '';
          if (this.expand) {
            itemsHtml += `<b>${this.field}: </b>${items[this.field]}`;
            itemsHtml += `<br><b>${this.image}: </b>${items[this.image]}`;
          } else {
            itemsHtml += `<b>${this.field}: </b>${items[this.field]}`;
          }
          return itemsHtml
        }
      }
    }
  }
</script>
